import React from "react";
import themeStyles from "../../../shared/styles/theme/theme-styles.module.scss";
import InputGroup from "../../components/inputGroup/InputGroup";
import styles from "./styles.module.scss";
import CustomSelect from "../../components/customSelect/customSelect";
import close from "../../../shared/images/close-modal.svg";

const UserAdminForm = (props) => {
  const formStatus = props.formStatus;

  const checkHandleSubmit = async (e, values) => {
    e.preventDefault();
    await props.setTouched(
      Object.keys(values).reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
      }, {}),
      true
    );
    if (
      Object.keys(props.touched).length > 0 &&
      Object.keys(props.errors).length === 0
    ) {
      const data = {
        name: values.name,
        lastname: values.lastName,
        email: values.email,
        role: values.role,
        password: values.password,
        accountType: values.accountType,
      };
      props.handleSubmit(data, formStatus);
    }
  };

  const handleOnFocus = (e) => {
    e.persist();
    setTimeout(() => {
      handleBlur(e);
    }, 500);
  };

  const checkHandleChange = (e) => {
    props.handleChange(e);
    props.setTouched({ ...touched, [e.target.name]: true });
  };

  const handleChangeSetup = (id) => {
    props.setFieldValue("role", id, true);
    props.setTouched({ ...touched, role: true });
  };

  const { t } = props;

  const renderButtons = () => {
    if (formStatus === "delete") {
      return (
        <div className={styles.buttonRow} style={{ marginTop: "20px" }}>
          <button
            className={themeStyles.btnSecondary}
            style={{ marginRight: "20px" }}
            onClick={() => props.changeStatus(null)}
          >
            Cancel
          </button>
          <button
            className={themeStyles.btnSecondary}
            onClick={() => props.handleDelete()}
          >
            Yes
          </button>
        </div>
      );
    }
    return (
      <div className={`${styles.buttonRow}`}>
        {formStatus === "edit" && (
          <button
            className={themeStyles.btnDanger}
            onClick={() => props.changeStatus("delete")}
            style={{ marginRight: "20px" }}
            type="button"
          >
            {t("common:actions.delete")}
          </button>
        )}
        <button
          className={`${themeStyles.btnPrimaryLT} `}
          type="button"
          onClick={(e) => checkHandleSubmit(e, values)}
          style={{
            background: formStatus === "edit" ? "#B1EA52B2" : "#FFFFFFCC",
          }}
        >
          {t("common:actions.save")}
        </button>
      </div>
    );
  };

  const { handleBlur, errors, touched, values } = props;
  const { name, lastName, email, role, password, accountType } = values;

  return (
    <div>
      <span className={styles.title}>
        <h2>{`${
          formStatus === "edit"
            ? "Edit User"
            : formStatus === "delete"
            ? "Are you sure you want to delete this user?"
            : "Create User"
        }`}</h2>
        <img src={close} alt="close" onClick={() => props.changeStatus(null)} />
      </span>

      <div className={`${styles.formBackground} `}>
        {formStatus === "delete" ? (
          renderButtons()
        ) : (
          <form className={styles.form}>
            <div className={styles.containerGeneral}>
              <InputGroup
                name="name"
                label={"First Name"}
                touched={touched}
                errors={errors}
                placeholder={"First Name"}
                onBlur={handleBlur}
                onFocus={handleOnFocus}
                inputValue={name}
                onChange={(e) => checkHandleChange(e)}
                className={styles.inputUser}
              />
              <InputGroup
                name="lastName"
                label={"Last Name"}
                touched={touched}
                errors={errors}
                onBlur={handleBlur}
                onFocus={handleOnFocus}
                inputValue={lastName}
                onChange={(e) => checkHandleChange(e)}
                placeholder={"Last Name"}
                className={styles.inputUser}
              />
              <InputGroup
                name="email"
                label={"Email"}
                touched={touched}
                errors={errors}
                onBlur={handleBlur}
                onFocus={handleOnFocus}
                inputValue={email}
                onChange={(e) => checkHandleChange(e)}
                placeholder={"Email"}
                className={styles.inputUser}
              />
              <CustomSelect
                name="role"
                label={"Role"}
                options={[
                  { value: "administrator", valueDisplay: "Administrator" },
                  { value: "producer", valueDisplay: "Producer" },
                ]}
                value={role}
                onSelect={handleChangeSetup}
                className={styles.input}
                errors={errors}
                placeholder={"Select the role"}
                onChange={(e) => checkHandleChange(e)}
              />
              {formStatus === "add" && (
                <div className={`${styles.column}`}>
                  <InputGroup
                    name="password"
                    label={"Password"}
                    inputValue={password}
                    inputType="password"
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    onFocus={handleOnFocus}
                    onChange={(e) => checkHandleChange(e)}
                    placeholder={"Password"}
                    className={styles.inputUser}
                    preventAutofill={"new-password"}
                  />
                </div>
              )}
              <CustomSelect
                name="accountType"
                label={"Account Type"}
                options={[
                  { value: "Freemium", valueDisplay: "Freemium" },
                  { value: "Premium", valueDisplay: "Premium" },
                ]}
                value={accountType}
                className={styles.input}
                errors={errors}
                placeholder={"Select Account Type"}
                onChange={(e) => checkHandleChange(e)}
              />
            </div>
            {renderButtons()}
          </form>
        )}
      </div>
    </div>
  );
};

export default UserAdminForm;
